// extracted by mini-css-extract-plugin
module.exports = {"card":"EmptyMessage_card__p0Hvf","title":"EmptyMessage_title__d_XRP","microcopy":"EmptyMessage_microcopy__bcOoJ"};